import { DEFAULT_FOUNDER_IMAGE, STORE_NAME } from '@/lib/brand'

export const FOUNDERS_DESK_CONTENT = {
  name: 'Mir Shahid Ul Haq',
  title: 'Founder & CEO, OOUDH KRAFT',
  message: `Assalamu Alaikum,

Welcome to OOUDH KRAFT, a proudly Kashmiri fragrance brand born from a passion for authenticity, quality, and excellence.

My name is Mir Shahid Ul Haq, and as a student and entrepreneur, I founded OOUDH KRAFT with a simple yet meaningful vision: to provide customers with premium-quality fragrances while protecting them from counterfeit and misleading products that have become increasingly common in the market.

At OOUDH KRAFT, we believe that a fragrance is more than just a scent—it is a reflection of personality, confidence, and lasting memories. Every perfume in our collection is carefully selected and crafted to deliver exceptional quality, rich aromas, and long-lasting performance that our customers can trust.

Being a brand rooted in the beautiful land of Kashmir, we carry forward the values of honesty, dedication, and craftsmanship in everything we do. Our commitment is not only to offer the finest perfumes but also to build lasting relationships with our customers through transparency and genuine value.

As we continue this journey, we remain dedicated to bringing you fragrances that inspire confidence, create unforgettable impressions, and stand apart in quality.

Thank you for your trust and support. We look forward to being a part of your fragrance journey.

Warm Regards,
Mir Shahid Ul Haq
Founder & CEO
OOUDH KRAFT`,
  quote:
    'Success is not built overnight; it is created through consistency, passion, and the courage to turn dreams into reality. Keep moving forward, and your efforts will eventually become your legacy.',
  portrait: DEFAULT_FOUNDER_IMAGE,
  subtitle: `A letter on craft, intention, and the fragrances we pour at ${STORE_NAME}.`,
} as const
